import React from 'react'
import './Services.css'
import Card from './Card'
import react from '/Users/kritikpatni/portfolio-website/src/Assets/atomic-energy-2.png'
import c from '/Users/kritikpatni/portfolio-website/src/Assets/software.png'
import ws from '/Users/kritikpatni/portfolio-website/src/Assets/web.png'
import {useContext} from "react"
import {themeContext, ThemeProvider} from '/Users/kritikpatni/portfolio-website/src/Context.js'
import {motion} from 'framer-motion';
function Services() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;


  const transition ={duration :2,type:'spring'}
  
  return (
    <div className='services'>
       <div className="awesome">
       <span style={{ color: darkMode ? "white" : "" }}>My </span>
        <span>Skills
        </span>
        <spane>
        I am a software developer with 2 years of working experience.Frontend is my mainstream skillset
          <br />
          Being efficient in React libraries assists me in managing and delivering products with ease.
        </spane>
        <button className="button s-button">Download CV</button>
           
       </div>


       <div className='cards'>
         <motion.div 
         whileInView={{left:'24rem'}}
         initial={{left:'25%'}}
         transition={transition}
         style={{left:'14rem'}}>
            <Card 
            emoji= {react}
            heading={'Frontend Development'}
            detail={'Frontend Development using react and javascript'}
            />
         </motion.div>

         
         <motion.div 
         whileInView={{left:'4rem'}}
         initial={{left:'25%'}}
         transition={transition}

         style={{left:'-4rem', top:"12rem"}}>
            <Card 
            emoji= {c}
            heading={'Languages'}
            detail={'C, C++, Java, JavaScript'}
            />
         </motion.div>

         <motion.div
         whileInView={{left:'24rem'}}
         initial={{left:'25%'}}
         transition={transition}
         style={{left:'12rem', top:"19rem"}}>
            <Card 
            emoji= {ws}
            heading={'Styling'}
            detail={'CSS,Bootstrap,Trailwind'}
            />
         </motion.div>
        


       </div>
    </div>
  )
}

export default Services


